import React from "react";
import logoCITT from "../../media/Logo_CITT.png";
import LogoUE from "../../media/logoUE.jpg"
import "./footer.css";

const Footer = ({ pageIndex }) => {
  return (
      <div className="footerWrapper border-primary">
          {/*<div className="logoWrapper footerLogo">*/}
          {/*    <img alt="CITT logo" src={logoCITT}/>*/}
          {/*</div>*/}
              {/*<>*/}
              {/*    CENTRUM INKUBACJI I&nbsp;TRANSFERU TECHNOLOGII*/}
              {/*    <br/>*/}
              {/*    POLITECHNIKI ŚLĄSKIEJ*/}
              {/*    <br/>*/}
              {/*    ul. Stefana Banacha 7<br/>*/}
              {/*    44-100 Gliwice*/}
              {/*    <br/>*/}
              {/*</>*/}

          <div style={{textAlign:"center"}}>
              <img src={LogoUE} style={{width: "515px"}}/>
              <p style={{fontSize:"x-small"}}>Aplikacja została sfinansowana z programu pod nazwą „Inkubator Innowacyjności 4.0”
                  finansowanego ze środków europejskich w ramach projektu pozakonkursowego „Wsparcie
                  zarządzania badaniami naukowymi i komercjalizacja wyników prac B+R w jednostkach naukowych i
                  przedsiębiorstwach”, realizowanego w ramach Programu Operacyjnego Inteligentny Rozwój 2014-
                  2020.</p>
          </div>
          <div className={"pageIndex"}>{pageIndex}</div>
      </div>
  );
};

export default Footer;
